
let photowrapGlobal = '{photowrap-var}';
console.log(photowrapGlobal, 'PROPORÇÃO');
